import React, { useEffect } from 'react'
import { isIOS } from '../../ReusableFunctions'
import CustomButton from '../forms/CustomButton'
import { set } from 'lodash'
import BasicModal from '../Modal'
import { useMediaQuery } from '@mui/material'
import logo from "../../../assets/images/ipmmi-logo.svg"
import a2hsTutorialImg from "../../../assets/images/A2HS-tutorial.jpg"
import { useLocation } from 'react-router-dom'


const A2HSTutorial = () => {
  const [start, setStart] = React.useState(true)
  const [prompt, setPrompt] = React.useState(null)
  const location = useLocation()
  const isMobile = useMediaQuery('(max-width: 768px)')
  useEffect(() => {
    if (location.pathname === "/install") {
      setStart(false)
      setPrompt(true)
    }
  }, [])
  if (isMobile && isIOS())
  return (
    <>
      {start && <BasicModal open={start} handleClose={() => setStart(false)} hideCloseButton closeOnBackdropClick>
        <div className='flex-col gap-10'>
          <div className='flex-row justify-center'>
            <img src={logo} width={"60"} alt="" />
          </div>
          <h1 className='f-s-14 text-center px-3 manrope-medium'>Do you want to add IPMMI on your Mobile Home Screen?</h1>
          <div className='flex-row gap-10 justify-center'>

            <CustomButton className={"primary-btn a2hs-add"} onClick={() => {
              setStart(false)
              setPrompt(true)
            }}>Add </CustomButton>
            <CustomButton className={"delete-btn"} onClick={() => {
              setStart(false)
            }}>Not Now</CustomButton>
          </div>
        </div>
      </BasicModal>}
      {prompt && <BasicModal className={"edit-member-modal"} open={prompt} handleClose={() => setPrompt(false)} closeOnBackdropClick>
        <A2HSModal />
      </BasicModal>}
    </>
  )
}

export default A2HSTutorial



const A2HSModal = () => {
  return (
    <div className='a2hs-tutorial'>
      <p className='f-s-18 manrope-medium pb-4'>Here is how you can install IPMMI</p>
      <img src={a2hsTutorialImg} alt="" />
    </div>
  )
}

